import React from "react";
import {
    TableRow,
    TableCell,
    Skeleton,
    Box,
    Avatar,
} from "@mui/material";

const cellStyle = {
    padding: '10px 16px',
    border: 'none',
    backgroundColor: '#fff',
};

const MemberSkeleton = () => {
    return (
        <>
            <TableRow>
                <TableCell sx={{
                    ...cellStyle,
                    minWidth: '32px',
                    maxWidth: '32px',
                    borderRadius: '10px 0 0 10px'
                }}>
                    <Skeleton variant="circular" width={20} height={20} />
                </TableCell>

                <TableCell sx={cellStyle}>
                    <Skeleton width={20} />
                </TableCell>

                <TableCell sx={{ ...cellStyle }}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Skeleton variant="circular" width={40} height={40} />
                        <Box>
                            <Skeleton width={80} height={20} />
                            <Skeleton width={60} height={14} />
                        </Box>
                    </Box>
                </TableCell>

                <TableCell sx={{ ...cellStyle, textAlign: 'center' }}>
                    <Box display="flex" justifyContent="center" gap={-1}>
                        <Skeleton variant="circular" width={32} height={32} />
                        <Skeleton variant="circular" width={32} height={32} />
                        <Skeleton variant="circular" width={32} height={32} />
                    </Box>
                </TableCell>

                <TableCell sx={{ ...cellStyle, textAlign: 'center' }}>
                    <Skeleton width={40} />
                </TableCell>

                <TableCell sx={{ ...cellStyle, textAlign: 'center' }}>
                    <Skeleton variant="rectangular" width={100} height={10} />
                </TableCell>

               

                <TableCell sx={{
                    ...cellStyle,
                    textAlign: 'center',
                    borderRadius: '0px 10px 10px 0px'
                }}>
                    <Skeleton width={60} />
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell colSpan={10} sx={{
                    padding: 0,
                    border: 'none',
                }}>
                    <Box p={2} sx={{ backgroundColor: '#f9f9f9' }}>
                        <Skeleton height={40} />
                        <Skeleton height={40} sx={{ mt: 1 }} />
                        <Skeleton height={40} sx={{ mt: 1 }} />
                    </Box>
                </TableCell>
            </TableRow>
        </>
    );
};

export default MemberSkeleton;
